module.exports = __webpack_public_path__ + "static/media/Ticket_icon.2e4a6b64.svg";